import React from 'react';
import Acord27Form from './Acord27Form';
import type { Acord27FormRef } from './Acord27Form';

export type { Acord27FormRef };

// Every prop the plain form takes, minus the one this wrapper sets. Spreading them keeps the
// "+ ACORD 101" variant in lockstep with the base form: before this, the wrapper re-listed the
// props by hand and silently dropped onLoadingChange, onCoverageMapping and friends, so on a
// +101 form the parent never learned which policies mapped (every policy looked unmapped) and
// the Loading state could never clear.
type Acord27With101FormProps = Omit<React.ComponentPropsWithoutRef<typeof Acord27Form>, 'showAcord101'>;

const Acord27With101Form = React.forwardRef<Acord27FormRef, Acord27With101FormProps>(
  function Acord27With101Form(props, ref) {
    return <Acord27Form ref={ref} showAcord101 {...props} />;
  }
);

export default Acord27With101Form;
